if (!customElements.get('dh-cart-attribute')) {
  customElements.define(
    'dh-cart-attribute',
    class DhCartAttribute extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[name^="attributes["]');
        this.status = this.querySelector('[role="status"]');
        this.input?.addEventListener('change', () => this.persist());
      }

      persist() {
        const attributeName = this.input.name.slice(11, -1);
        const body = JSON.stringify({ attributes: { [attributeName]: this.input.value } });

        this.input.setAttribute('aria-busy', 'true');
        if (this.status) this.status.textContent = 'Saving invoice information.';

        fetch(routes.cart_update_url, { ...fetchConfig(), body })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to save cart attribute');
            return response.json();
          })
          .then(() => {
            if (this.status) this.status.textContent = 'Invoice information saved.';
          })
          .catch(() => {
            if (this.status) this.status.textContent = 'Invoice information could not be saved. Try again.';
          })
          .finally(() => this.input.removeAttribute('aria-busy'));
      }
    }
  );
}
